import React from 'react';
import { useLazyQuery } from '@apollo/client';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { statusEmailQuery } from '../../api';

export const PCEmail = (props: any) => {
  const [visible, setVisible] = React.useState(false);
  const [loadResult, { called, loading, data }] = useLazyQuery(statusEmailQuery, {
    variables: {
      assetNumber: props.row.assetNumber,
      barcode: props.row.barCode,
      process: 'transfer',
    },
  });
  return (
    <div style={{ textAlign: 'center' }}>
      <Button variant='info' onClick={() => setVisible(true)}>
        <i className='fa fa-paper-plane' data-toggle='tooltip' data-placement='top' title='Send email to property coordinators' />
      </Button>
      <Modal show={visible} onHide={() => setVisible(false)}>
        {/* <Modal.Title className='form-inline mt-3 ml-3'>Send {props.process} Emails?</Modal.Title> */}
        <Modal.Body>
          <h4>
            Would you like to send {props.process} emails to the property coordinators for {props.toDept}?
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <h6>* Emails are automatically sent as part of the {props.process} process. These emails would serve as a reminder.</h6>

          <Button
            variant='info'
            onClick={() => {
              !data && loadResult();
            }}>
            {!called && 'Yes'}
            {called && loading && <Spinner animation='border' />}
            {data && 'Sent!'}
          </Button>

          <Button variant='primary' onClick={() => setVisible(false)}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
      {/* {visible && alert(`Send new ${props.process} emails to PCs for ${props.toDept}?`)} */}
    </div>
  );
};
